import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    container: {
        height: 'calc(100vh - 83px)',
        display: 'flex',
        flexDirection: 'column',
        padding: '8px',
        boxSizing: 'border-box',
        gap: 8,
        overflow: 'hidden',
    },
    filterBar: {
        flexShrink: 0,
    },
    pageTitle: {
        flexShrink: 0,
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '24px',
        color: '#2B2C35',
        padding: '4px 4px 0',
    },
}));

export default useStyles;
